import { Component, Input } from '@angular/core';
import { ActivityLocation, IBoondock } from '@curbnturf/entities';
import { IonicModule, ModalController } from '@ionic/angular';
import { DonationComponent } from '../donation/donation.component';

@Component({
  selector: 'curbnturf-donation-modal-page',
  templateUrl: './donation-modal-page.html',
  styleUrls: ['./donation-modal-page.scss'],
  standalone: true,
  imports: [IonicModule, DonationComponent],
})
export class DonationModalPage {
  @Input() confirmationCode?: string;

  @Input() boondockSite: IBoondock;

  @Input() poi: ActivityLocation;

  constructor(private modalController: ModalController) {}

  async onCloseModal() {
    await this.modalController.dismiss();
  }
}
